import { Fragment, type ReactNode } from 'react';

/** `**bold**`, `` `code` `` and `[text](url)`, the inline forms a change file may use (QZ-D190). */
const INLINE = /\*\*([^*]+)\*\*|`([^`]+)`|\[([^\]]+)\]\(([^)\s]+)\)/g;

const isWebUrl = (url: string): boolean => /^https?:\/\//i.test(url);

/**
 * Renders a changelog entry's inline Markdown as React elements. Only the three forms above
 * become markup; anything else, HTML included, stays text, and a link whose target is not
 * `http(s)` keeps only its text.
 */
export const inlineMarkdown = (text: string): ReactNode[] => {
  const nodes: ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(INLINE)) {
    const index = match.index;
    if (index > last) nodes.push(text.slice(last, index));
    const [, bold, code, linkText, url] = match;
    if (bold !== undefined) {
      nodes.push(<strong key={index}>{bold}</strong>);
    } else if (code !== undefined) {
      nodes.push(<code key={index}>{code}</code>);
    } else if (isWebUrl(url)) {
      nodes.push(
        <a key={index} href={url} target="_blank" rel="noopener noreferrer">
          {linkText}
        </a>
      );
    } else {
      nodes.push(<Fragment key={index}>{linkText}</Fragment>);
    }
    last = index + match[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
};
